import { useEffect, useState } from 'react'
import { sendGet, sendPost } from '../../hooks/use-fetch'
import { type SelectOption } from '../../Components/SelectWithLabel'
import { Box, Button } from '@mui/material'
import { CheckList } from '../../Components/CheckList'
import { DatePickerWithLabel } from '../../Components/DatePicker'
import { toast } from 'react-toastify'

export interface ProgramExportOptionsProps {
  isdUser: boolean
}

export function ProgramExportOptions (props: ProgramExportOptionsProps): JSX.Element {
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [programs, setPrograms] = useState<Array<SelectOption<number>>>([])
  const [selectedPrograms, setSelectedPrograms] = useState<Array<SelectOption<number>>>([])
  const [serviceProviders, setServiceProviders] = useState<Array<SelectOption<number>>>([])
  const [selectedServiceProviders, setSelectedServiceProviders] = useState<Array<SelectOption<number>>>([])

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response } = await sendGet('/Reporting/ISDPrograms?withStateCodeOnly=false', {})
      setPrograms(response)
      if (props.isdUser) {
        const { response: response2 } = await sendGet('/Reporting/ISDServiceProviders', {})
        setServiceProviders(response2)
      }
    }

    void fetchData()
  }, [])

  const openReport = async (): Promise<void> => {
    if (startDate === null || endDate === null) {
      toast.error('Please enter both date values.')
    } else if (selectedPrograms.length === 0) {
      toast.error('Please select one or more programs.')
    } else if (props.isdUser && selectedServiceProviders.length === 0) {
      toast.error('Please select one or more service providers.')
    } else {
      const providerList = selectedServiceProviders.map(s => s.id)
      const programList = selectedPrograms.map(p => p.id)
      const { response, success } = await sendPost('/Reporting/ProgramExportReportURL', { startDate, endDate, isdServiceProviderIDs: providerList, isdProgramIDs: programList })
      if (success) {
        window.open(response, '_blank')?.focus()
      }
    }
  }

  return <Box className='mt-10'>
    <DatePickerWithLabel
      required={true}
      label='Start Date'
      name='startDate'
      onChange={setStartDate}
      value={startDate}
    />

    <DatePickerWithLabel
      required={true}
      label='End Date'
      name='endDate'
      onChange={setEndDate}
      value={endDate}
    />

    <CheckList label='Programs' items={programs} selectedItems={selectedPrograms} setSelectedItems={setSelectedPrograms} allOption={true} />

    {props.isdUser && <CheckList label='Service Providers' items={serviceProviders} selectedItems={selectedServiceProviders} setSelectedItems={setSelectedServiceProviders} allOption={true} />}

    <Box className='mt-10'>
      <Button color='secondary' variant='contained' onClick={openReport}>Preview</Button>
    </Box>
  </Box >
}
